module.exports = __webpack_public_path__ + "static/media/authentication-bg-old.d3694463.jpg";